<template>
  <div v-if="video.pid != 0">
    <div class="single-video-title box mb-3">
      <h2 v-if="options.video.show.video.title && video.title.length > 0">
        <a href="#">
          {{ video.title }}
        </a>
      </h2>
      <p class="mb-0">
        <i class="fas fa-eye" /> {{ video.view_count }} {{ $t('JSON.views') }}
        &nbsp;
        <i class="fas fa-calendar-alt" /> {{ video.published_at }}
        (<Timeago
          locale="en"
          :datetime="video.published_at"
          :converter-options="{ includeSeconds: false, addSuffix: true }"
        />)
        &nbsp;
        <i
          v-if="$auth.check()"
          class="fas fa-lock"
          @click="inspect"
        />
      </p>
    </div>
    <div
      v-if="options.video.show.video.channel"
      class="single-video-author box mb-3"
    >
      <div class="float-right">
        <button
          class="btn btn-danger"
          type="button"
        >
          {{ $t('JSON.subscribe') }} <strong>1.4M</strong>
        </button>
        <button
          class="btn btn btn-outline-danger"
          type="button"
        >
          <i class="fas fa-bell" />
        </button>
      </div>
      <img
        class="img-fluid"
        src="@/assets/theme/img/s4.png"
        alt=""
      >
      <p>
        <a href="#">
          <strong>{{ video.channel_title }}</strong>
        </a> <span
          title=""
          data-placement="top"
          data-toggle="tooltip"
          data-original-title="Verified"
        >
          <i class="fas fa-check-circle text-success" />
        </span>
      </p>
      <small>{{ $t('JSON.published-on') }} {{ video.published_at }}</small>
    </div>
    <div
      v-if="(options.video.show.video.description && video.description.length > 0) || (options.video.show.video.tags && video.tags.length > 0)"
      class="single-video-info-content box mb-3"
    >
      <!-- <h6>Cast:</h6> -->
      <!-- <p>Nathan Drake , Victor Sullivan , Sam Drake , Elena Fisher</p> -->
      <!-- <h6>Category :</h6> -->
      <!-- <p>Gaming , PS4 Exclusive , Gameplay , 1080p</p> -->
      <template v-if="options.video.show.video.description && video.description.length > 0">
        <h6>{{ $t('JSON.description') }} :</h6>
        <p>
          {{ video.description }}
        </p>
      </template>
      <template v-if="options.video.show.video.tags && video.tags.length > 0">
        <h6>{{ $t('JSON.tags') }} :</h6>
        <p class="tags mb-0">
          <b-badge
            v-for="tag in video.tags"
            :key="tag.slug"
            variant="success"
            @click="selectTag(tag)"
          >
            {{ tag.name }}
          </b-badge>
        </p>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    video: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    inspect() {
      Bus.$emit('inspect_post', this.data.pid);
    },

    selectTag(tag) {
      // console.log('tag clicked', tag);
      Bus.$emit('tags_selected', [tag]);
      this.$router.push({
        name: 'home',
      });
    },
  },
};
</script>

<style scoped>
.tags .badge {
  cursor: pointer;
  margin-right: 2px;
  margin-bottom: 3px;
  padding-bottom: 4px;
  text-transform: capitalize;
  font-size: 1em;
}
</style>
